<template>
  <div class="spine-rehab-container">
    <router-view />
    <van-tabbar v-model="active" active-color="#1976D2" inactive-color="#000" route @change="onChange">
      <van-tabbar-item icon="home-o" replace to="/Shunyi/home">首页
      </van-tabbar-item>

      <van-tabbar-item icon="contact-o" replace to="/Shunyi/person">我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'ShunyiHome',
  data () {
    return {
      active: 'home',
      isWxMiniProgram: false
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.user.profile.isLogin
    }
  },
  mounted () {
    this.isWxMiniProgram = this.isWxMiniCodeWebviewEnv()
    console.log('是否在小程序环境', this.isWxMiniProgram)
    console.log('登录用户', this.$store.state.user)
  },
  methods: {
    isWxMiniCodeWebviewEnv () {
      try {
        return (
          typeof window !== 'undefined' &&
          typeof window.wx !== 'undefined' &&
          typeof window.wx.miniProgram !== 'undefined'
        )
      } catch (error) {
        console.warn('检查微信小程序环境时发生错误:', error)
        return false
      }
    },
    onConsultClick () {
      if (this.isWxMiniProgram) {
        // 从store获取用户信息
        const userProfile = this.$store.state.user.profile
        const phone = encodeURIComponent(userProfile.phone || '')
        const realname = encodeURIComponent(userProfile.name || '')

        window.wx.miniProgram.navigateTo({
          url: `/pages/spine_consult/spine_consult?phone=${phone}&name=${realname}`
        })
      }
    },
    login () {
      this.$router.push('/login/index')
    },
    onChange (val) {
      // 可以在这里处理tab切换事件
    }
  }
}
</script>

<style scoped>
/* 确保主容器占满整个视口高度 */
.spine-rehab-container {
  min-height: 100vh;
  padding-bottom: 50px;
  /* 为底部 tabbar 预留空间 */
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* 固定 tabbar 在底部 */
:deep(.van-tabbar) {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(25, 118, 210, 0.1);
}

:deep(.van-tabbar-item__text) {
  font-size: 12px;
  font-weight: 500;
}

:deep(.van-tabbar-item--active .van-tabbar-item__text) {
  color: #1976D2;
  font-weight: 600;
}
</style>
